var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-popup',{attrs:{"title":_vm.title,"active":_vm.active},on:{"update:active":function($event){_vm.active=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }